import {Association} from '@eitje/api'
import {useFiltersCache} from '../hooks'
import _ from 'lodash'

// Pass 'debug: true' to useFilters if you want to see which filter makes items disappear.

export const useFilters = ({items, name, orgCacheKey, filters, filteredItems, debug}) => {
	const cachedFilterValues = useFiltersCache({name, orgCacheKey})
	const notFiltered = _.isEmpty(cachedFilterValues)

	if (!items) return
	if (notFiltered) return new Association(items)

	const debugLog = log => debug && console.log(log)
	debugLog('\n### FILTERS DEBUG ###')

	filters.forEach(({filterName, filterFn}) => {
		debugLog(filterName)
		debugLog(`Old: ${items.length}`)

		const filterValue = cachedFilterValues[filterName]
		const shouldFilter = !_.isEmpty(filterValue)

		// pass 'filteredItems' for the 'userWithFilteredItems' filter
		if (shouldFilter) items = items.filter(item => filterFn(item, filterValue, filteredItems))
		debugLog(`New: ${items.length}`)
	})

	return new Association(items)
}
